import { type PropsWithChildren } from 'react';

import { XYChartAxesFormatterProvider } from './XYChartAxesFormatterProvider.js';
import { XYChartAxesTicksProvider } from './XYChartAxesTicksProvider.js';
import { XYChartScalesProvider } from './XYChartScalesProvider.js';
import { XYChartVisibleAxesScalesProvider } from './XYChartVisibleAxesScalesProvider.js';

export const XYChartProviders = ({ children }: PropsWithChildren) => (
  <XYChartScalesProvider>
    <XYChartAxesFormatterProvider>
      <XYChartVisibleAxesScalesProvider>
        <XYChartAxesTicksProvider>{children}</XYChartAxesTicksProvider>
      </XYChartVisibleAxesScalesProvider>
    </XYChartAxesFormatterProvider>
  </XYChartScalesProvider>
);
